import { render } from "./FormDate.vue?vue&type=template&id=2bb01a8e&ts=true"
import script from "./FormDate.vue?vue&type=script&lang=ts"
export * from "./FormDate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__